var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"print"}},[_c('table',{attrs:{"id":"barcodes"}},[_c('tbody',_vm._l((_vm.assets),function(asset){return _c('tr',[_c('td',[_c('barcode',{attrs:{"value":asset.number,"tag":'svg',"options":{
                            background: 'transparent',
                            displayValue: true,
                            format: 'CODE128',
                            width: 1,
                            height: 25
                        }}},[_vm._v("\n                        "+_vm._s(_vm.$t('ui.notifications.error.exception_error_please_contact_the_system_supplier'))+".\n                    ")])],1)])}))])])}
var staticRenderFns = []

export { render, staticRenderFns }